import { render, staticRenderFns } from "./FormBlock.vue?vue&type=template&id=0089f5de&scoped=true&"
import script from "./FormBlock.vue?vue&type=script&lang=js&"
export * from "./FormBlock.vue?vue&type=script&lang=js&"
import style0 from "./FormBlock.vue?vue&type=style&index=0&id=0089f5de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0089f5de",
  null
  
)

export default component.exports